import { SxProps, Theme } from "@mui/material";

export const reviewModalStyles = {
  rowCard: (issue: boolean): SxProps<Theme> => ({
    display: "flex",
    gap: 2,
    p: 2,
    borderRadius: "10px",
    border: "1px solid",
    borderColor: issue ? "warning.main" : "divider",
    bgcolor: issue ? "rgba(255, 152, 0, 0.05)" : "grey.50",
    alignItems: "flex-start",
    cursor: issue ? "pointer" : "default",
    transition: "background-color 0.15s",
    "&:hover": issue ? { bgcolor: "rgba(255, 152, 0, 0.12)" } : undefined,
  }),

  rowAvatar: (issue: boolean): SxProps<Theme> => ({
    width: 28,
    height: 28,
    fontSize: "0.75rem",
    bgcolor: issue ? "warning.main" : "primary.main",
    flexShrink: 0,
    mt: 0.25,
  }),

  emailIcon: { fontSize: 15, color: "text.secondary" } as SxProps<Theme>,

  statusChip: { ml: "auto", fontSize: "0.7rem", height: 20 } as SxProps<Theme>,

  warningIcon: { fontSize: 13 } as SxProps<Theme>,

  detailIcon: { fontSize: 14, color: "text.disabled" } as SxProps<Theme>,

  arrowIcon: {
    fontSize: 12,
    color: "warning.main",
    mt: 0.5,
    flexShrink: 0,
  } as SxProps<Theme>,

  dialogPaper: { borderRadius: "16px", overflow: "hidden" } as SxProps<Theme>,

  dialogContent: {
    pt: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
  } as SxProps<Theme>,

  dialogActions: {
    px: 3,
    py: 2,
    gap: 1,
    flexDirection: "column",
  } as SxProps<Theme>,

  sendBlockedBox: {
    color: "warning.main",
    alignSelf: "flex-start",
  } as SxProps<Theme>,

  sendBlockedIcon: { fontSize: 15 } as SxProps<Theme>,

  actionButton: {
    borderRadius: "8px",
    textTransform: "none",
    flex: 1,
  } as SxProps<Theme>,
};
